export default "{\n    \"guaranteeFasterPaymentLabel\": \"Garantissez un paiement plus rapide.\",\n    \"learnMoreButtonLabel\": \"En savoir plus\"\n}\n"